<ng-container *transloco="let t">
    <div class="main-content cart-content">
        <us-order-shipping-details [order]="cart()"></us-order-shipping-details>

        <div class="card">
            <div class="card-header">
                <h5 class="card-title">{{ t('selected_product') }}</h5>

                <button *ngIf="showAddItemButton()"
                        tuiButton
                        type="button"
                        size="s"
                        appearance="secondary"
                        [icon]="'svg::plus'"
                        [routerLink]="'/'">
                    {{ t('add_items') }}
                </button>
            </div>

            <div class="card-content">
                <us-order-items class="grid grid-cols-1 divide-y divide-gray-50"
                                (quantityChanged)="onChangeItemQuantity($event)"
                                [order]="cart()">
                </us-order-items>
            </div>
        </div>

        <div class="card"
             *ngIf="isCartOwner()">
            <div class="card-header">
                <h5 class="card-title">{{ t('total') }}</h5>
            </div>

            <div class="card-content">
                <ul class="divide-y divide-gray-200 dark:divide-gray-700 text-sm mt-2">
                    <li class="py-3 sm:py-4">
                        <div class="flex items-center justify-between">
                            <span>
                                {{ 'subtotal' | transloco }} ({{ cart().total_items + ' ' + ('item' | transloco) }})
                            </span>

                            <span class="text-gray-700 mb-px">
                                {{ cart().total_price || 0 | formatCurrency }}
                            </span>
                        </div>
                    </li>

                    <ng-container *ngIf="cart().order_type === OrderType.Delivery">
                        <li class="py-3 sm:py-4">
                            <div class="flex items-center justify-between">
                                <span>
                                    {{ t('delivery_fee') }}
                                    <span class="text-gray-500 font-normal ml-1">
                                        {{ delivery()?.service_name }}
                                    </span>
                                </span>

                                <span class="text-gray-700 mb-px">
                                    {{ delivery()?.delivery_fee || 0 | formatCurrency }}
                                </span>
                            </div>
                        </li>
                    </ng-container>

                    <li class="py-3 sm:py-4">
                        <div class="flex items-center justify-between">
                            <span> {{ 'discount' | transloco }} </span>
                            <span class="text-gray-700 mb-px">
                                {{ cart().discount?.price || 0 | formatCurrency }}
                            </span>
                        </div>
                    </li>

                    <li class="py-3 sm:py-4">
                        <div class="flex items-center justify-between">
                            <span> {{ 'surcharge' | transloco }} </span>
                            <span class="text-gray-700 mb-px">
                                {{ cart().surcharge?.price || 0 | formatCurrency }}
                            </span>
                        </div>
                    </li>

                    <!--<li class='py-3 sm:py-4'>
                        <us-promotion-select-v2></us-promotion-select-v2>
                    </li>-->

                    <!-- <li class="py-3 sm:py-4">
                        <button appearance="secondary"
                                tuiButton
                                type="button"
                                icon="svg::coupon"
                                size="s">
                            {{ 'select_coupon' | transloco }}
                        </button>
                    </li> -->
                </ul>
            </div>
        </div>

        <ng-container *ngIf="isCartOwner()">
            <div class="card">
                <div class="card-header">
                    <h5 class="card-title">{{ t('payment_methods') }}</h5>

                    <button tuiButton
                            type="button"
                            size="s"
                            appearance="flat"
                            (click)="togglePaymentMethodsSheet()">
                        {{ t('change') }}
                    </button>
                </div>

                <div class="card-content">
                    <div class="py-3 sm:py-4">
                        <button appearance="outline"
                                tuiButton
                                type="button"
                                [icon]="
                                selectedPaymentMethod()
                                    ? (selectedPaymentMethod()! | paymentTypeIcon)
                                    : 'svg::credit-card'
                            "
                                size="m"
                                (click)="togglePaymentMethodsSheet()"
                                class="w-full text-left">
                            <span>{{
                                selectedPaymentMethod()
                                ? t(selectedPaymentMethod()! | paymentTypeLabel : orderType())
                                : t('select_a_payment_method')
                                }}</span>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="isCartShared() && !isCartOwner()">
            <div class="flex items-center justify-center p-4">
                <a mode="negative"
                   tuiLink
                   class="text-red-500 font-medium"
                   (click)="leaveGroupOrder()">
                    {{ t('leave_the_group_order') }}
                </a>
            </div>
        </ng-container>
    </div>

    <footer class="sticky bottom-0 bg-white w-full border-t">
        <div class="p-4">
            <button *ngIf="isCartOwner(); else addItemsTmpl"
                    tuiButton
                    appearance="primary"
                    size="m"
                    class="w-full"
                    [showLoader]="loading()"
                    [disabled]="!cartItemsLength() || (cart().order_type === OrderType.Delivery && !cart().receiver)"
                    (click)="handleSubmitCart()">
                {{ t('ordering') + ' - ' }}
                <span class="font-bold">{{ cart().grand_total || 0 | formatCurrency }}</span>
            </button>

            <ng-template #addItemsTmpl>
                <button tuiButton
                        appearance="primary"
                        size="m"
                        class="w-full"
                        [icon]="'tuiIconPlus'"
                        [routerLink]="'/'">
                    {{ t('add_items') }}
                </button>
            </ng-template>
        </div>
    </footer>

    <ng-template [tuiSheet]="showPaymentMethodsSheet()"
                 (tuiSheetChange)="showPaymentMethodsSheet.set($event)"
                 [tuiSheetOptions]="options">
        <h2 tuiSheetHeading>
            <label>{{ 'payment_methods' | transloco }}</label>
        </h2>

        <us-payment-type-options [options]="paymentMethods()"
                                 [value]="selectedPaymentMethod()"
                                 (valueChange)="onChangePaymentType($event)"
                                 [orderType]="orderType()!"></us-payment-type-options>
    </ng-template>
</ng-container>